// react
import React, { useRef, useState } from 'react'

// external libs
import { FormHelperText, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ContentState, EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
// import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

// hooks
import useManageMenuStore from '../../stores/manageMenu/useManageMenuStore'
import useRichTextfield2 from './useRichTextEditorts2'


export type InitialRichTextEditorType = {
    contentHtml: string
    contentText: string
}
let MyRichTextFieldView: React.FC<any> = ({
    field,
    required,
    maxLength = 9999999,
    materialInputProps = {},
    type,
    icon,
    initialRichTextEditor,
    disabled,
    isHideToolbar = false,
    label,
    commentTitle,
    commentTitleID,
    topicCount,
    topicID,
    committeeID,
    ...other
}) => {
    const getInitialState = (content: any) => {
        const blocksFromHtml = htmlToDraft(`${content}`)
        const contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap)
        return EditorState.createWithContent(contentState)
    }

    const { input, meta } = field
    const isError = meta.error && meta.invalid && meta.touched ? true : false
    const classes = useStyles(isError)

    const [editorState, setEditorState] = React.useState(() => EditorState.createEmpty())
    const MAX_LENGTH = maxLength
    let textLength = React.useRef<number>(0)

    const manageMenuStore = useManageMenuStore()
    const { isOpen } = manageMenuStore

    /// --- set initial --- ///
    React.useEffect(() => {
        setEditorState(getInitialState(initialRichTextEditor?.contentHtml ?? ''))
        const initialValueObj = {
            contentHtml: initialRichTextEditor?.contentHtml ?? '',
            contentText: initialRichTextEditor?.contentText ?? '',
        }

        input.onChange(initialValueObj)
        textLength.current = initialRichTextEditor?.contentHtml?.length
    }, [initialRichTextEditor?.contentHtml, initialRichTextEditor?.contentText])

    
    const getTextFromHtml = (html: string) => {
        const blocksFromHtml = htmlToDraft(html)
        const contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap)
        return contentState.getPlainText()
    }

    const getLengthOfSelectedText = () => {
        const currentSelection = editorState.getSelection()
        const isCollapsed = currentSelection.isCollapsed()

        let length = 0

        if (!isCollapsed) {
            const currentContent = editorState.getCurrentContent()
            const startKey = currentSelection.getStartKey()
            const endKey = currentSelection.getEndKey()
            const startBlock = currentContent.getBlockForKey(startKey)
            const isStartAndEndBlockAreTheSame = startKey === endKey
            const startBlockTextLength = startBlock.getLength()
            const startSelectedTextLength = startBlockTextLength - currentSelection.getStartOffset()
            const endSelectedTextLength = currentSelection.getEndOffset()
            const keyAfterEnd = currentContent.getKeyAfter(endKey)

            if (isStartAndEndBlockAreTheSame) {
                length += currentSelection.getEndOffset() - currentSelection.getStartOffset()
            } else {
                let currentKey = startKey

                while (currentKey && currentKey !== keyAfterEnd) {
                    if (currentKey === startKey) {
                        length += startSelectedTextLength + 1
                    } else if (currentKey === endKey) {
                        length += endSelectedTextLength
                    } else {
                        length += currentContent.getBlockForKey(currentKey).getLength() + 1
                    }

                    currentKey = currentContent.getKeyAfter(currentKey)
                }
            }
        }

        return length
    }
    const handleBeforeInputFunc = () => {
        const currentContent = editorState.getCurrentContent()
        const currentContentLength = currentContent.getPlainText('').length
        const selectedTextLength = getLengthOfSelectedText()

        if (currentContentLength - selectedTextLength > MAX_LENGTH - 1) {
            return 'handled'
        }
    }

    const handlePastedTextFunc = (pastedText: any) => {
        const currentContent = editorState.getCurrentContent()
        const currentContentLength = currentContent.getPlainText('').length
        const selectedTextLength = getLengthOfSelectedText()

        if (currentContentLength + pastedText.length - selectedTextLength > MAX_LENGTH) {
            return true
        } else {
            return false
        }
    }

    let calWidth = 0
    if (window.innerWidth >= 1920 && isOpen) {
        calWidth = window.innerWidth - 155
    } else {
        calWidth = window.innerWidth - 175
    }

    if (isOpen) {
        calWidth = calWidth - 260
    }
    return (
        <>
            <div>
                <Editor
                    readOnly={disabled}
                    editorState={editorState}
                    editorStyle={{
                        backgroundColor: disabled ? '#f3f3f3' : '',
                    }}
                    wrapperClassName={classes.editorWrapper}
                    editorClassName="rdw-editor-main"
                    //editorClassName={textLength.current > 1100 ? 'home-editor' : classes.mainEditor}
                    //@ts-ignore
                    handleBeforeInput={handleBeforeInputFunc}
                    handlePastedText={handlePastedTextFunc}
                    onEditorStateChange={(val) => {
                        setEditorState(val)
                        const content = val.getCurrentContent()
                        const rawObject = convertToRaw(content)
                        const htmlTag = draftToHtml(rawObject)
                        const blocks = rawObject.blocks
                        const textValue = blocks.map((block) => (!block.text.trim() && '\n') || block.text).join('\n')
                        input.onChange({
                            contentHtml: htmlTag,
                            contentText: textValue,
                        })
                        textLength.current = textValue.length
                    }}
                    toolbarHidden={isHideToolbar}
                    toolbar={{
                        options: ['inline', 'fontSize', 'fontFamily', 'textAlign', 'colorPicker', 'list', 'history'],
                    }}
                />
            </div>
        </>
    )
}

let MyRichTextFieldCtrl: React.FC<any> = ({
    handleValueChange,
    name,
    required,
    validates,
    maxLength,
    isDraftNotRequire,
    ...others
}) => {
    const richTextFieldModel = useRichTextfield2({
        name,
        required,
        validates,
        isDraftNotRequire,
    })
    return (
        <MyRichTextFieldView
            maxLength={maxLength}
            required={required}
            handleValueChange={handleValueChange}
            {...richTextFieldModel}
            {...others}
        />
    )
}

export default MyRichTextFieldCtrl

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
    editorWrapper: {
        border: '1px solid #bdbdbd',
        borderRadius: 2,
        minHeight: 200,
        resize: 'vertical',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',

        '& .rdw-editor-main': {
            flex: 1,
            overflow: 'auto',
            padding: 5,
        },
    },

    mainEditor: {
        border: '1px solid #bdbdbd !important',
        padding: '5px !important',
        borderRadius: '2px !important',
        height: '200px !important',
    },
}))
